package com.ilussobsa.views.dialogs

import com.ilussobsa.views.LogInScreen

import com.lightningkite.kiteui.models.*
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*
import com.ilussobsa.Strings
import com.ilussobsa.views.SettingsScreen
import com.lightningkite.kiteui.views.l2.icon

fun  ViewWriter.userModal(close: ()->Unit) = sizeConstraints(minWidth = 20.rem) - col {
    row {
        expanding - link {
            row {
                centered - icon(Icon.settings, "")
                centered - text(Strings.settings)
            }
            to = { SettingsScreen() }
            onNavigate { close() }
        }
        expanding - link {
            row {
                centered - icon(Icon.logout, "")
                centered - text(Strings.logOut)
            }
            to = { LogInScreen() }
            onNavigate { close() }
        }
    }
}